/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { useTheme } from "@material-ui/core/styles";
import EnhancedTable from "../../Tables/EnhancedTable";
import Button from "components/common_components/Button";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

function DataSearchDialog({ open, title, primaryButtonText, secondaryButtonText, onClose, onPrimaryClick, onSecondaryClick, tableProps }) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const [data, setData] = useState([]);
    const [pageableData, setPageableData] = useState(undefined);
    const [selectedRows, setSelectedRows] = useState([]);
    const { data: initialData, keyColumnName, onRequestData } = tableProps;

    async function loadData(data) {
        const { data: resData, pageableData: resPageableData } = await onRequestData(data);
        setData(resData);
        setPageableData(resPageableData);
    }

    useEffect(() => {
        loadData();

        return () => {
            setData([]);
            setPageableData(undefined);
        };
    }, []);

    function onCloseHandler() {
        setSelectedRows([]);
        onClose();
    }

    function onPrimaryClickHandler(event) {
        const rows = data.filter((x) => selectedRows.some((y) => y === x[keyColumnName]));
        onPrimaryClick(rows);
        onCloseHandler();
    }

    function onSecondaryClickHandler(event) {
        onSecondaryClick();
        onCloseHandler();
    }

    function onRowDoubleClickHandler(row) {
        onPrimaryClick([row]);
        onCloseHandler();
    }

    return (
        <div>
            <Dialog
                maxWidth="md"
                fullWidth
                open={open}
                fullScreen={fullScreen}
                TransitionComponent={Transition}
                keepMounted
                // onClose={onClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle id="alert-dialog-slide-title">{title}</DialogTitle>
                <DialogContent>
                    {open && (
                        <EnhancedTable
                            {...{
                                ...tableProps,
                                allowSelectAll: false,
                                allowMultiSelect: false,
                                selectable: true,
                                onSelectedChanged: setSelectedRows,
                                data: initialData || data,
                                onRowDoubleClick: onRowDoubleClickHandler,
                                onRequestData: loadData,
                                pageableData: pageableData,
                            }}
                        />
                    )}
                </DialogContent>
                <DialogActions>
                    <Button primary outline onClick={onSecondaryClickHandler}>
                        {secondaryButtonText}
                    </Button>
                    <Button primary onClick={onPrimaryClickHandler}>
                        {primaryButtonText}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}

DataSearchDialog.propTypes = {
    open: PropTypes.bool,
    title: PropTypes.node,
    primaryButtonText: PropTypes.string,
    secondaryButtonText: PropTypes.string,
    onClose: PropTypes.func.isRequired,
    onPrimaryClick: PropTypes.func,
    onSecondaryClick: PropTypes.func,
    tableProps: PropTypes.shape({
        headCells: PropTypes.arrayOf(
            PropTypes.shape({
                index: PropTypes.number,
                id: PropTypes.string,
                label: PropTypes.string,
            }),
        ),
        data: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string,
            }),
        ),
        dense: PropTypes.bool,
        defaultOrder: PropTypes.shape({
            order: PropTypes.string,
            orderBy: PropTypes.string,
        }),
        keyColumnName: PropTypes.string,
        selectable: PropTypes.bool,
        allowSelectAll: PropTypes.bool,
        allowMultiSelect: PropTypes.bool,
        onSelectedChanged: PropTypes.func,
        deletable: PropTypes.bool,
        onRequestData: PropTypes.func,
    }),
};

DataSearchDialog.defaultProps = {
    open: false,
    title: "",
    primaryButtonText: "Select",
    secondaryButtonText: "Cancel",
    onPrimaryClick: () => {},
    onSecondaryClick: () => {},
    tableProps: {
        headCells: [],
        data: [],
        dense: false,
        defaultOrder: undefined,
        keyColumnName: "id",
        selectable: true,
        allowSelectAll: false,
        allowMultiSelect: false,
        onSelectedChanged: () => {},
        deletable: false,
        onRequestData: async () => {},
    },
};

export default DataSearchDialog;
